import { SlickFormatting } from "@serenity-is/corelib";
import { htmlEncode } from "@serenity-is/corelib/q";

var orgItemLink = SlickFormatting.itemLink;
SlickFormatting.itemLink = function (itemType, idField, getText, cssClass, encode) {
    var formatter = orgItemLink(itemType, idField, getText, cssClass, encode);
    return function (ctx) {
        if (ctx.row == -1 && ctx.cell == -1) {
            var txt = (getText == null ? ctx.value : getText(ctx)) ?? '';
            return encode ? htmlEncode(txt) : txt;
        }

        return formatter(ctx);
    }
}
